import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService, } from '@app/core/features/auth';
import { paths, constants } from '@app/constants';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authService.checkoutAccount()) {
      return of(true);
    } else {
      if (state.url === '/') {
        this.cookieService.set(constants.returnUrl, paths.CHARTS_MANAGER);
        this.router.navigate([paths.SIGN_IN], { replaceUrl: true });
      } else {
        this.cookieService.set(constants.returnUrl, state.url, null, '/');
        this.authService.loginRedirect();
      }
    }

    return of(false);
  }
}
